<template>
  <div class="flex flex-wrap">
    <!-- <div class="bg-white rounded-md shadow overflow-x-auto"> -->

    <select v-model="filter" class="form-select mt-1 w-64">
      <option :value="null">Alle</option>
      <option :value="'finished'">Uitgelezen</option>
      <option :value="'in_possession'">In bezit</option>
      <option :value="'queued'">Op wachtlijst</option>
    </select>

    <table class="w-full whitespace-nowrap">
      <tr class="text-left font-bold">
        <th class="pb-4 pt-6 px-6">User</th>
        <th
          class="pb-4 pt-6 cursor-pointer"
          @click="toggleOrder('loans.created_at')"
        >
          Op wachtlijst
        </th>
        <th
          class="pb-4 pt-6 cursor-pointer"
          @click="toggleOrder('loans.start')"
        >
          In bezit
        </th>
        <th
          class="pb-4 pt-6 cursor-pointer"
          @click="toggleOrder('loans.finished')"
        >
          Uitgelezen
        </th>
        <th
          class="pb-4 pt-6 cursor-pointer"
          @click="toggleOrder('loans.lent_out')"
        >
          Uitgeleend
        </th>
      </tr>
      <tr
        v-for="loan in filteredLoans"
        :key="loan.id"
        class="hover:bg-gray-100 focus-within:bg-gray-100"
      >
        <td class="border-t">
          <Link
            class="flex items-center px-6 py-4 focus:text-indigo-500"
            :href="`/users/${loan.user.data.id}?activeTab=details`"
          >
            <img
              v-if="loan.user.data.avatar"
              :src="loan.user.data.avatar"
              :alt="loan.user.data.name"
              class="rounded-full h-8 w-8 object-cover pr-2"
            />
            <span>{{ loan.user.data.name }}</span>
          </Link>
        </td>
        <td class="border-t">
          <!-- <Link class="flex items-center px-6 py-4" :href="`/books/${bookItem.book_id}?activeTab=${bookItem.serial}`" tabindex="-1"> -->
          <div
            :class="setTimeWarning(loan, 'queued')"
            class="inline-block text-sm p-1 rounded"
          >
            {{ loan.queued_formatted }}
          </div>
          <!-- </Link> -->
        </td>
        <td class="border-t">
          <!-- <Link class="flex items-center px-6 py-4" :href="`/books/${bookItem.book_id}?activeTab=${bookItem.serial}`" tabindex="-1"> -->
          <div
            :class="setTimeWarning(loan, 'start')"
            class="inline-block text-sm p-1 rounded"
          >
            {{ loan.start_formatted }}
          </div>
          <!-- </Link> -->
        </td>
        <td class="border-t">
          <!-- <Link class="flex items-center px-6 py-4" :href="`/books/${bookItem.book_id}?activeTab=${bookItem.serial}`" tabindex="-1"> -->
          {{ loan.finished_formatted }}
          <!-- </Link> -->
        </td>
        <td class="border-t">
          <!-- <Link class="flex items-center px-6 py-4" :href="`/books/${bookItem.book_id}?activeTab=${bookItem.serial}`" tabindex="-1"> -->
          {{ loan.lent_out_formatted }}
          <!-- </Link> -->
        </td>
      </tr>
      <tr v-if="filteredLoans.length === 0" class="border-t">
        <td class="px-6 py-4" colspan="5">Geen uitleningen gevonden.</td>
      </tr>
    </table>
    <!-- </div> -->
  </div>
</template>

<script>
import throttle from "lodash/throttle";
import moment from "moment";
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Link,
  },
  props: {
    bookItem: Object,
    order: String,
    direction: String,
  },
  data() {
    return {
      sort: {
        direction: this.direction,
        order: this.order,
      },
      filter: null,
    };
  },

  computed: {
    filteredLoans() {
      return this.bookItem.loans.data.filter((loan) => {
        switch (this.filter) {
          case "finished":
            return !!loan.finished;
          case "in_possession":
            return !!loan.start && !loan.lent_out;
          case "queued":
            return !loan.start && !loan.finished && !loan.lent_out;
          default:
            return loan;
        }
      });
    },
    activeLoan() {
      return this.bookItem.loans.data.find(
        (loan) => loan.start && !loan.lent_out
      );
    },
    firstInQueue() {
      if (this.activeLoan?.finished) {
        return this.bookItem.loans.data
          .filter((loan) => !loan.start && !loan.finished && !loan.lent_out)
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0];
      }
      return undefined;
    },
  },

  watch: {
    sort: {
      deep: true,
      handler: throttle(function () {
        this.fetchBook();
      }, 150),
    },
  },
  methods: {
    fetchBook() {
      this.$inertia.get(
        `/books/${this.bookItem.book_id}`,
        {
          activeTab: this.bookItem.serial,
          order: this.sort.order,
          direction: this.sort.direction,
        },
        { preserveState: true }
      );
    },

    toggleOrder(field) {
      if (this.sort.order != field) {
        this.sort.direction = "desc";
      } else {
        this.sort.direction = this.sort.direction === "asc" ? "desc" : "asc";
      }

      this.sort.order = field;
    },

    generateClasses(weeksPassed) {
      const classes = [];

      if (weeksPassed >= 3) {
        classes.push(`bg-red-${Math.min(weeksPassed * 100, 900)}`);
      }

      if (weeksPassed >= 4) {
        classes.push("text-white");
      }

      return classes.join(" ");
    },

    setTimeWarning(loan, type) {
      if (
        type === "start" &&
        this.activeLoan &&
        this.activeLoan.id === loan.id
      ) {
        if (!loan.finished) {
          let weeksPassed = moment(new Date()).diff(
            moment(loan.start),
            "weeks"
          );

          return this.generateClasses(weeksPassed);
        }
      } else if (
        type === "queued" &&
        this.firstInQueue &&
        this.firstInQueue.id === loan.id
      ) {
        let weeksPassed = moment(new Date()).diff(
          moment(loan.created_at),
          "weeks"
        );

        return this.generateClasses(weeksPassed);
      }
    },
  },
};
</script>

